module.exports = __webpack_public_path__ + "img/allahverdiev.b677e671.jpg";